import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import ThemedSelect from "../shared/ThemedSelect";
import { useDirtyState } from "../../hooks/useDirtyState";
import { DirtyStateDialog } from "../shared/DirtyStateDialog";

const CreateStockPrices = ({ formData, handleChange, handleSubmit, isUpdating, stocks, setFormData }) => {
    const { markDirty, resetDirty, showDialog, confirmNavigation, cancelNavigation } = useDirtyState(formData);

    const stockOptions = stocks.map((stock) => ({
        value: stock.stock_symbol,
        label: `${stock.stock_symbol} - ${stock.company_name}`,
    }));

    const handleStockChange = (selectedOption) => {
        setFormData((prev) => {
            const updated = {
                ...prev,
                fk_stock_symbol: selectedOption ? selectedOption.value : "",
            };
            markDirty(updated);
            return updated;
        });
    };

    const selectedStock = stockOptions.find((option) => option.value === formData.fk_stock_symbol);

    const handleLocalChange = (e) => {
        handleChange(e);
        const { name, value } = e.target;
        const updated = { ...formData, [name]: value };
        markDirty(updated);
    };

    const handleFormSubmit = (e) => {
        handleSubmit(e);
        resetDirty();
    };

    return (
        <>
            <Card className="mb-6">
                <CardHeader>
                    <CardTitle>{isUpdating ? "Modifier les prix" : "Ajouter des prix"}</CardTitle>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleFormSubmit}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="grid w-full gap-1.5">
                                <Label htmlFor="stockprice-date">Date (timestamp UNIX)</Label>
                                <Input
                                    id="stockprice-date"
                                    type="text"
                                    name="price_date"
                                    value={formData.price_date}
                                    onChange={handleLocalChange}
                                    placeholder="Date (UNIX Timestamp)"
                                    required
                                    disabled={isUpdating}
                                />
                            </div>
                            <div className="grid w-full gap-1.5">
                                <Label htmlFor="stockprice-open">Prix d'ouverture</Label>
                                <Input
                                    id="stockprice-open"
                                    type="number"
                                    step="0.01"
                                    name="open_price"
                                    value={formData.open_price}
                                    onChange={handleLocalChange}
                                    placeholder="Prix d'ouverture"
                                    required
                                />
                            </div>
                            <div className="grid w-full gap-1.5">
                                <Label htmlFor="stockprice-close">Prix de clôture</Label>
                                <Input
                                    id="stockprice-close"
                                    type="number"
                                    step="0.01"
                                    name="close_price"
                                    value={formData.close_price}
                                    onChange={handleLocalChange}
                                    placeholder="Prix de clôture"
                                    required
                                />
                            </div>
                            <div className="grid w-full gap-1.5">
                                <Label htmlFor="stockprice-high">Prix le plus haut</Label>
                                <Input
                                    id="stockprice-high"
                                    type="number"
                                    step="0.01"
                                    name="high_price"
                                    value={formData.high_price}
                                    onChange={handleLocalChange}
                                    placeholder="Prix le plus haut"
                                    required
                                />
                            </div>
                            <div className="grid w-full gap-1.5">
                                <Label htmlFor="stockprice-low">Prix le plus bas</Label>
                                <Input
                                    id="stockprice-low"
                                    type="number"
                                    step="0.01"
                                    name="low_price"
                                    value={formData.low_price}
                                    onChange={handleLocalChange}
                                    placeholder="Prix le plus bas"
                                    required
                                />
                            </div>
                            <div className="grid w-full gap-1.5">
                                <Label htmlFor="stockprice-volume">Volume</Label>
                                <Input
                                    id="stockprice-volume"
                                    type="number"
                                    name="volume"
                                    value={formData.volume}
                                    onChange={handleLocalChange}
                                    placeholder="Volume"
                                    required
                                />
                            </div>
                        </div>

                        <div className="grid w-full gap-1.5 mt-4">
                            <Label htmlFor="stockprice-stock-select">Action (symbole)</Label>
                            <ThemedSelect
                                id="stockprice-stock-select"
                                options={stockOptions}
                                value={selectedStock}
                                onChange={handleStockChange}
                                placeholder="Sélectionnez une action"
                                isDisabled={isUpdating}
                                isClearable
                            />
                        </div>

                        <Button type="submit" className="mt-4">
                            {isUpdating ? "Enregistrer" : "Ajouter"}
                        </Button>
                    </form>
                </CardContent>
            </Card>
            <DirtyStateDialog open={showDialog} onConfirm={confirmNavigation} onCancel={cancelNavigation} />
        </>
    );
};

export default CreateStockPrices;
